<script>
  import { onMount } from "svelte";

  import { fade } from "svelte/transition";
  import Redirect from "../../components/backDashboard.svelte";
  import DisplayNotification from "./displayNotification.svelte";
  import { user } from "../../firebase";
  import { conversion, lang } from "../../store/store.js";
  const { doc } = $user;
  let notifications = {};
  let data;
  console.log(
    "-----------////////////// Yassine testing //////////// -----------------"
  );
  console.log(window.location.href);

  const unsubscribeNotif = $user.notifications.subscribe((v) => {
    data = v;
    console.log(data);
    notifications = Object.entries(JSON.parse(JSON.stringify(data)));

    notifications.sort((a, b) => parseInt(b[1].date) - parseInt(a[1].date));
    console.log(notifications);
  });

  onMount(() => {
    (async () => {
      if ($doc.unread) {
        $user.update.profile({ unread: 0 });
      }
    })();

    return () => {
      unsubscribeNotif();
    };
  });

  let menuCond = false;
  let menu = [
    {
      name: $conversion[$lang].notifications.filters.all,
      value: "all",
    },
    {
      name: $conversion[$lang].notifications.filters.comment,
      value: "comment",
      img: "../images/notification/message.svg",
    },
    {
      name: $conversion[$lang].notifications.filters.status,
      value: "status",
      img: "../images/notification/status.svg",
    },
    {
      name: $conversion[$lang].notifications.filters.package,
      img: "../images/notification/package.svg",
    },
  ];
  let selected = {
    name: $conversion[$lang].notifications.generalTitle,
    value: "all",
  };
  let title = $conversion[$lang].notifications.backToDashBoardTitle;

  $: {
    if (!!document.getElementById("menu")) {
      if (menuCond) {
        document.getElementById("menu").style.display = "flex";
      } else {
        document.getElementById("menu").style.display = "none";
      }
    }
  }
</script>

<!--
     {#each projects as project, i}
            <DisplayNotification bind:project  />
        {/each}
-->
<style>
  .contentWrapper {
    /* padding-bottom: 6rem; */
    padding: 2rem 1rem 6rem 1rem;
    width: 95%;
    max-width: 1350px;
    position: absolute;
  }

  .dropdown-menu {
    margin-left: auto;
    position: relative;
    outline: none;
    border: 1px solid #d8e0f0;
    box-shadow: 0px 1px 2px rgba(184, 200, 224, 0.222055);
    border-radius: 14px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    padding: 0.7rem 1.15rem 0.7rem 2rem;
    font-size: 0.9em;
    color: black;
    cursor: pointer;
    width: 100%;
    max-width: 270px;
    background: white;
    margin-bottom: 1.5rem;
  }

  .arrow {
    position: absolute;
    top: 50%;
    right: 0px;
    transform: translate(-50%, -50%) rotate(90deg);
    padding: 0.1rem 0.5rem;
    border-radius: 50%;
  }

  .dropdown-menu-rest {
    position: absolute;
    top: 77%;
    left: -1px;
    width: 101%;
    background-color: white;
    display: none;
    flex-direction: column;
    border-bottom-right-radius: 14px;
    border-bottom-left-radius: 14px;
    box-shadow: 0px 1px 2px rgba(184, 200, 224, 0.222055);
    border: 1px solid #d8e0f0;
    padding: 0.8rem 1.15rem 0.5rem 1rem;
    color: black;
    z-index: 500;
    border-top: none;
  }

  .option-ctn {
    display: flex;
    padding: 0.325rem 0.5rem;
    cursor: pointer;
  }

  .option-name {
    font-size: 0.9em;
    color: black;
    font-weight: 600;
  }

  .all-notifications-wrapper {
    display: flex;
    flex-direction: column;
    background: #ffffff;
    box-shadow: 0px 6px 58px rgba(196, 203, 214, 0.103611);
    border-radius: 24px;
    padding: 2rem;
  }

  .option-img {
    margin-right: 0.5rem;
    display: flex;
  }

  .n-img {
    margin-right: 1rem;
    height: 15px;
  }

  .n-title {
    font-weight: 500;
    font-size: 1.25rem;
    color: #0a1629;
  }

  ::-webkit-scrollbar {
    width: 5px;
    border-radius: 20px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: var(--primaryColor);
    border-radius: 10px;
  }

  .n-wrapper {
    display: flex;
    flex-direction: column;
    max-height: 75vh;
    overflow-y: scroll;
    padding-right: 0.4rem;
  }

  .project-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: center;
    border-radius: 16px;
    overflow: hidden;
    background-color: transparent;
    margin-bottom: 2rem;
    position: relative;
  }
  .color {
    font-size: 0.9em;
    color: black;
    font-weight: 600;
  }

  .line {
    width: 0.2rem;
    background-color: #e4e6e8;
  }

  /*           PROJECT LEFTSIDE           */
  .project-leftside {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 1.5rem 1.75rem;
    background-color: white;
  }

  .project-num {
    font-size: 0.875em;
    color: #91929e;
    font-weight: 400;
    margin-bottom: 0.5rem;
  }

  .project-name {
    font-size: 1.125em;
    font-weight: 700;
    margin-bottom: 0.75rem;
    color: black;
  }

  .leftside-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .project-date-img {
    height: 25px;
    margin-right: 0.5rem;
  }

  .project-date-txt {
    font-size: 0.875em;
    font-weight: 500;
    color: #7d8592;
  }
  .row {
    display: flex;
    align-items: center;
  }

  .project-priority-arrow {
    height: 25px;
    margin-right: 0.5rem;
    display: flex;
    align-items: center;
  }

  .project-priority-txt {
    font-size: 0.875em;
    font-weight: 600;
  }

  /*             RIGHTSIDE             */

  .project-rightside {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 1.5rem 1.75rem;
    background-color: white;
  }

  .project-title {
    font-size: 1em;
    font-weight: 700;
    margin-bottom: 1rem;
    color: black;
  }

  .rightside-wrapper {
    display: flex;
    justify-content: space-between;
  }

  .column {
    width: 30%;
    display: flex;
    flex-direction: column;
  }

  .rightside-txt {
    font-size: 0.875em;
    font-weight: 400;
    margin-bottom: 0.5rem;
    color: #91929e;
  }

  .rightside-num {
    font-size: 1em;
    font-weight: 700;
    color: black;
  }

  @media only screen and (max-width: 1100px) {
    .contentWrapper {
      padding-bottom: 0;
      width: 100%;
    }

    .n-wrapper {
      max-height: unset;
      overflow-y: unset;
    }
    .enlarge {
      margin-left: 1.25rem;
      margin-right: 1.25rem;
    }
  }
</style>

<div
  in:fade={{ duration: 300, delay: 300 }}
  out:fade={{ duration: 300, delay: 0 }}
  class="contentWrapper">
  <Redirect bind:title />
  <div
    on:click={() => {
      menuCond = !menuCond;
    }}
    class="dropdown-menu">
    <div class:on={menuCond} class="arrow">></div>
    <div class="color">{selected.name}</div>
    <div id="menu" class="dropdown-menu-rest">
      {#each menu as option}
        <div
          on:click={() => {
            selected = option;
          }}
          class="option-ctn">
          <div class="option-img"><img src={option.img} alt="" /></div>
          <div class="option-name">{option.name}</div>
        </div>
      {/each}
    </div>
  </div>
  <div class="all-notifications-wrapper">
    <div style="margin-bottom: 2rem;" class="row">
      <div class="n-img">
        <img src="../images/notification/bell.svg" alt="" />
      </div>
      <div class="n-title">{$conversion[$lang].notifications.generalTitle}</div>
    </div>
    <div class="n-wrapper">
      {#each notifications as [id, notification], i}
        {#if selected.value == 'all' || notification.changedField == selected.value}
          <DisplayNotification bind:notification />
        {/if}
      {/each}
    </div>
  </div>
</div>
